import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddCategoryMutationVariables = Types.Exact<{
  input: Types.AddCategoryInput;
}>;


export type AddCategoryMutation = { __typename?: 'Mutation', addCategory: { __typename?: 'CategoryPayload', data?: { __typename?: 'CategoryPayloadData', id: string, tenantId: string, category: { __typename?: 'CategoryData', code: string } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateCategoryMutationVariables = Types.Exact<{
  input: Types.UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'CategoryPayload', data?: { __typename?: 'CategoryPayloadData', id: string, tenantId: string, category: { __typename?: 'CategoryData', code: string } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RenameCategoryMutationVariables = Types.Exact<{
  input: Types.RenameCategoryInput;
}>;


export type RenameCategoryMutation = { __typename?: 'Mutation', renameCategory: { __typename?: 'CategoryPayload', data?: { __typename?: 'CategoryPayloadData', id: string, tenantId: string, category: { __typename?: 'CategoryData', code: string } } | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type SetCategoryIncomeGlAccountMutationVariables = Types.Exact<{
  input: Types.SetCategoryIncomeGlAccountInput;
}>;


export type SetCategoryIncomeGlAccountMutation = { __typename?: 'Mutation', setCategoryIncomeGlAccount: { __typename?: 'CategoryPayload', data?: { __typename?: 'CategoryPayloadData', id: string, tenantId: string, category: { __typename?: 'CategoryData', code: string } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveCategoryMutationVariables = Types.Exact<{
  input: Types.RemoveCategoryInput;
}>;


export type RemoveCategoryMutation = { __typename?: 'Mutation', removeCategory: { __typename?: 'CategoryPayload', data?: { __typename?: 'CategoryPayloadData', id: string, tenantId: string, category: { __typename?: 'CategoryData', code: string } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null } };

export type InactivateCategoryMutationVariables = Types.Exact<{
  input: Types.InactivateCategoryInput;
}>;


export type InactivateCategoryMutation = { __typename?: 'Mutation', inactivateCategory: { __typename?: 'CategoryPayload', data?: { __typename?: 'CategoryPayloadData', id: string, tenantId: string, category: { __typename?: 'CategoryData', code: string } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateCategoryMutationVariables = Types.Exact<{
  input: Types.ActivateCategoryInput;
}>;


export type ActivateCategoryMutation = { __typename?: 'Mutation', activateCategory: { __typename?: 'CategoryPayload', data?: { __typename?: 'CategoryPayloadData', id: string, tenantId: string, category: { __typename?: 'CategoryData', code: string } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchRemoveCategoriesMutationVariables = Types.Exact<{
  input: Types.BatchRemoveCategoriesInput;
}>;


export type BatchRemoveCategoriesMutation = { __typename?: 'Mutation', batchRemoveCategories: { __typename?: 'CategoryBulkActionPayload', categories?: Array<{ __typename?: 'CategoryPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null } };

export type BatchInactivateCategoriesMutationVariables = Types.Exact<{
  input: Types.BatchInactivateCategoriesInput;
}>;


export type BatchInactivateCategoriesMutation = { __typename?: 'Mutation', batchInactivateCategories: { __typename?: 'CategoryBulkActionPayload', categories?: Array<{ __typename?: 'CategoryPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchActivateCategoriesMutationVariables = Types.Exact<{
  input: Types.BatchActivateCategoriesInput;
}>;


export type BatchActivateCategoriesMutation = { __typename?: 'Mutation', batchActivateCategories: { __typename?: 'CategoryBulkActionPayload', categories?: Array<{ __typename?: 'CategoryPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AddCategoryDocument = new TypedDocumentString(`
    mutation AddCategory($input: AddCategoryInput!) {
  addCategory(input: $input) {
    data {
      ...Category
    }
    errors {
      code
      message
    }
  }
}
    fragment Category on CategoryPayloadData {
  id
  tenantId
  category {
    ...CategoryData
  }
}
fragment CategoryData on CategoryData {
  code
}`);
export const UpdateCategoryDocument = new TypedDocumentString(`
    mutation UpdateCategory($input: UpdateCategoryInput!) {
  updateCategory(input: $input) {
    data {
      ...Category
    }
    errors {
      code
      message
    }
  }
}
    fragment Category on CategoryPayloadData {
  id
  tenantId
  category {
    ...CategoryData
  }
}
fragment CategoryData on CategoryData {
  code
}`);
export const RenameCategoryDocument = new TypedDocumentString(`
    mutation RenameCategory($input: RenameCategoryInput!) {
  renameCategory(input: $input) {
    data {
      ...Category
    }
    errors {
      message
    }
  }
}
    fragment Category on CategoryPayloadData {
  id
  tenantId
  category {
    ...CategoryData
  }
}
fragment CategoryData on CategoryData {
  code
}`);
export const SetCategoryIncomeGlAccountDocument = new TypedDocumentString(`
    mutation SetCategoryIncomeGlAccount($input: SetCategoryIncomeGlAccountInput!) {
  setCategoryIncomeGlAccount(input: $input) {
    data {
      ...Category
    }
    errors {
      code
      message
    }
  }
}
    fragment Category on CategoryPayloadData {
  id
  tenantId
  category {
    ...CategoryData
  }
}
fragment CategoryData on CategoryData {
  code
}`);
export const RemoveCategoryDocument = new TypedDocumentString(`
    mutation RemoveCategory($input: RemoveCategoryInput!) {
  removeCategory(input: $input) {
    data {
      ...Category
    }
    errors {
      ...RecordValidationError
    }
  }
}
    fragment Category on CategoryPayloadData {
  id
  tenantId
  category {
    ...CategoryData
  }
}
fragment CategoryData on CategoryData {
  code
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const InactivateCategoryDocument = new TypedDocumentString(`
    mutation InactivateCategory($input: InactivateCategoryInput!) {
  inactivateCategory(input: $input) {
    data {
      ...Category
    }
    errors {
      code
      message
    }
  }
}
    fragment Category on CategoryPayloadData {
  id
  tenantId
  category {
    ...CategoryData
  }
}
fragment CategoryData on CategoryData {
  code
}`);
export const ActivateCategoryDocument = new TypedDocumentString(`
    mutation ActivateCategory($input: ActivateCategoryInput!) {
  activateCategory(input: $input) {
    data {
      ...Category
    }
    errors {
      code
      message
    }
  }
}
    fragment Category on CategoryPayloadData {
  id
  tenantId
  category {
    ...CategoryData
  }
}
fragment CategoryData on CategoryData {
  code
}`);
export const BatchRemoveCategoriesDocument = new TypedDocumentString(`
    mutation BatchRemoveCategories($input: BatchRemoveCategoriesInput!) {
  batchRemoveCategories(input: $input) {
    categories {
      errors {
        ...RecordValidationError
      }
    }
    errors {
      ...RecordValidationError
    }
  }
}
    fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const BatchInactivateCategoriesDocument = new TypedDocumentString(`
    mutation BatchInactivateCategories($input: BatchInactivateCategoriesInput!) {
  batchInactivateCategories(input: $input) {
    categories {
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const BatchActivateCategoriesDocument = new TypedDocumentString(`
    mutation BatchActivateCategories($input: BatchActivateCategoriesInput!) {
  batchActivateCategories(input: $input) {
    categories {
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddCategory: build.mutation<AddCategoryMutation, AddCategoryMutationVariables>({
      query: (variables) => ({ document: AddCategoryDocument, variables })
    }),
    UpdateCategory: build.mutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>({
      query: (variables) => ({ document: UpdateCategoryDocument, variables })
    }),
    RenameCategory: build.mutation<RenameCategoryMutation, RenameCategoryMutationVariables>({
      query: (variables) => ({ document: RenameCategoryDocument, variables })
    }),
    SetCategoryIncomeGlAccount: build.mutation<SetCategoryIncomeGlAccountMutation, SetCategoryIncomeGlAccountMutationVariables>({
      query: (variables) => ({ document: SetCategoryIncomeGlAccountDocument, variables })
    }),
    RemoveCategory: build.mutation<RemoveCategoryMutation, RemoveCategoryMutationVariables>({
      query: (variables) => ({ document: RemoveCategoryDocument, variables })
    }),
    InactivateCategory: build.mutation<InactivateCategoryMutation, InactivateCategoryMutationVariables>({
      query: (variables) => ({ document: InactivateCategoryDocument, variables })
    }),
    ActivateCategory: build.mutation<ActivateCategoryMutation, ActivateCategoryMutationVariables>({
      query: (variables) => ({ document: ActivateCategoryDocument, variables })
    }),
    BatchRemoveCategories: build.mutation<BatchRemoveCategoriesMutation, BatchRemoveCategoriesMutationVariables>({
      query: (variables) => ({ document: BatchRemoveCategoriesDocument, variables })
    }),
    BatchInactivateCategories: build.mutation<BatchInactivateCategoriesMutation, BatchInactivateCategoriesMutationVariables>({
      query: (variables) => ({ document: BatchInactivateCategoriesDocument, variables })
    }),
    BatchActivateCategories: build.mutation<BatchActivateCategoriesMutation, BatchActivateCategoriesMutationVariables>({
      query: (variables) => ({ document: BatchActivateCategoriesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddCategoryMutation, useUpdateCategoryMutation, useRenameCategoryMutation, useSetCategoryIncomeGlAccountMutation, useRemoveCategoryMutation, useInactivateCategoryMutation, useActivateCategoryMutation, useBatchRemoveCategoriesMutation, useBatchInactivateCategoriesMutation, useBatchActivateCategoriesMutation } = injectedRtkApi;
